import { Icon, IconProps } from "..";

export const ConeyIsland = (props: IconProps) => {
  return (
    <Icon {...props}>
      <>
        <path d="M8.47615 8H10.8571V28H8.47615V8Z" />
        <path d="M26.3334 13H27.5238V8H26.3334V9.25H25.1429V10.5H21.5715V11.75H19.1905V9.25H13.2381V10.5H12.0477V20.5H13.2381V19.25H15.6191V18H18V20.5H22.7619V19.25H23.9524V16.75H25.1429V15.5H26.3334V13Z" />
      </>
    </Icon>
  );
};
